import React, { Component, createRef, Fragment } from "react";
import {
  Hero,
  Title,
  TechniqueTitle,
  ClientTag,
  CaseWrapper,
  BackButton,
  BackArrow
} from "../styles/Case.styles";

import Reveal from 'react-reveal/Reveal';
import { withRouter } from "react-router";
import Footer from '../components/Footer';
import { Efectr, Efectr1, Efectr2  } from "../styles/effect.styles";

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

class Case extends Component {
  constructor(props) {
    super(props);
    this.introRef = createRef();

    this.state = {
          toBack: false,
          introTop: 0,
          hasBackground: false,
          animateCase: ""
        };
      }
    
      componentDidUpdate() {
        if (this.state.toBack) {
          setTimeout(() => {
            this.props.setNavBackground(false);
            this.props.history.push("/blog");
          }, 400);
        }
        if (this.state.animateCase) {
          setTimeout(() => {
            this.props.setNavBackground(false);
    
            this.props.history.push(this.state.animateCase);
            window.scrollTo(0, 0);
          }, 400);
        }
      }
    
    
      render() {
        return (
          <Fragment>
          <Efectr/>
          <Efectr1/>
          <Efectr2/>
          <ScrollTop>
            <CaseWrapper>
              <Reveal effect="fadeIn">
                <Hero className='mainhero' style={{ backgroundImage: "url('./img/imgabout.jpg')" }}>
                    <div className='herocaption'>
                      <BackButton className='backdetail'
                        onClick={() => this.setState({ toBack: true, hasBackground: false })}
                        toBack={this.state.toBack}
                        hasBackground={this.state.hasBackground}>
                        <BackArrow src="./img/back.png" alt="Back to blog" />
                        <span>Back </span>
                      </BackButton>
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12 pl-md-0'>
                            <ClientTag className='date'>March 15, 2024</ClientTag>
                            <Title>Protein: The Magic Macro</Title>
                            <TechniqueTitle>
                            Is Protein Magic? No. But, it does provide many health benefits! 
                            </TechniqueTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                </Hero>
              </Reveal>
    
              <section className='container' id='detailproject'>
                <div className='row'>
                  <div className='col-md-12'>
                    <p className='content'>Protein stands as a critical component for the maintenance of our skin, 
                      hair, nails, brain, nerves, and of course our muscular structure. Consequently, ensuring an 
                      adequate daily intake holds significant importance. Particularly in the realm of physical 
                      fitness, protein emerges as a cornerstone. It facilitates muscle development, augments strength, 
                      and expedites tissue recovery following injury. Furthermore, prioritizing protein consumption 
                      can serve to mitigate age-related muscle deterioration, thereby fostering sustained physical 
                      well-being as we age.</p>
                    <p className='content'>In addition, increasing one's dietary protein consumption can benefit 
                      weight management. The satiety provided by protein-rich foods translates into reduced cravings 
                      for late-night snacks and sugary indulgences. Moreover, protein's capacity to heighten metabolic 
                      activity contributes to increased calorie expenditure, particularly during resistance and strength 
                      training. Thus, integrating ample protein into our daily regimen is paramount to fortifying our bodies 
                      and promoting overall vitality. </p>

                  
                    <h3 className='my-5'>How to Maximize Protein Health Benefits</h3>
                    <div>
                      <p className='content'>1. Resistance training: 2-4x per week doing one body segment per day on a weekly cycle (ex. Upper body day, lower body day, and core day).</p>
                      <p className='content'> 2. Eating enough protein daily: Aim for 1g of protein per 1 lbs of your body weight </p>
                      <p className='content'>3. High-Protein whole foods: examples include; chicken, turkey, pork, salmon, lentils, tofu, and greek yogurt</p>
                      <p className='content'>4. Supplements: protein powders (ex. Whey, casein, or pea protein)</p>
                      <p className='content'> 5. Expert help: Speak with your Naturopathic Doctor to learn more about the benefits of protein!</p>
                    </div>
                  </div>  

                  <div className='col-md-12'></div>
                  <div className='share'>
                    <span className='heading'>
                    Share this blog post :
                    </span>
                    <span className='content'> 
                    <a href="https://www.facebook.com/sharer/sharer.php?u=drmichellemaliknd.com/WOW1" target="_blank" rel="noopener noreferrer">  
                      <i className="fa fa-facebook-f"></i>
                      </a>  
                    </span>
                    <span className='content'> 
                    <a href="https://www.instagram.com/dr.michellemalik.nd" target="_blank" rel="noopener noreferrer">   
                      <i className="fa  fa-instagram"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </section>

            </CaseWrapper>
    
          </ScrollTop>
    
          <Footer />
    
          </Fragment>
        );
      }
    }
    
    export default withRouter(Case);
    